import { render, staticRenderFns } from "./TeodoroLocsinMessageDaySeafarer25June2021.vue?vue&type=template&id=242b1e9f&scoped=true"
import script from "./TeodoroLocsinMessageDaySeafarer25June2021.vue?vue&type=script&lang=js"
export * from "./TeodoroLocsinMessageDaySeafarer25June2021.vue?vue&type=script&lang=js"
import style0 from "./TeodoroLocsinMessageDaySeafarer25June2021.vue?vue&type=style&index=0&id=242b1e9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242b1e9f",
  null
  
)

export default component.exports